import styles from "./SortSelect.module.scss";
import { Button, Dropdown, Select } from "antd";
import classNames from "classnames";
import useDeviceCheck from "Hooks/useDeviceCheck";
import BackspaceIcon from "@mui/icons-material/Backspace";
import { IconButton } from "@mui/material";
import { useMemo } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { LoadingOutlined } from "@ant-design/icons";
import CheckIcon from "@mui/icons-material/Check";

export const SORT_TYPE = Object.freeze({
  FACULTY_LIST: 0,
  PUBLICATION: 1,
  GRANT: 2,
});

const SORT_MAP_SELECT = Object.freeze({
  [SORT_TYPE.FACULTY_LIST]: [
    { value: "name", label: "Name" },
    { value: "h_index", label: "h-index" },
  ],
  [SORT_TYPE.PUBLICATION]: [
    { value: "publication_year", label: "Year published" },
    { value: "citation_count", label: "Citations" },
  ],
  [SORT_TYPE.GRANT]: [
    { value: "start_date", label: "Start Date" },
    { value: "end_date", label: "End Date" },
    { value: "amount_awarded", label: "Amount Awarded" },
  ],
});

const SortSelect = ({
  sortType,
  sortData,
  setSortData,
  hasOrderType,
  className,
  filter,
  loading,
}) => {
  const { isMobile } = useDeviceCheck();
  const sortSelects = useMemo(() => {
    const data = [...(SORT_MAP_SELECT[sortType] || [])];
    if (sortType === SORT_TYPE.FACULTY_LIST && !!filter) {
      if (!!filter?.query || !!filter?.keywordQuery?.length > 0)
        data.push({ value: "relevance", label: "Relevance" });
      // if (filter?.keywordQuery?.length > 0)
      //   data.push({ value: "relevance", label: "Research relevance" });
    }
    if (isMobile && hasOrderType) {
      const mixData = data.flatMap((item) => [
        {
          key: `${item.value}|asc`,
          label: item.label,
        },
        {
          key: `${item.value}|desc`,
          label: `${item.label} (Descending)`,
        },
      ]);

      return mixData;
    }
    return data;
  }, [filter?.query, filter?.keywordQuery, sortType, isMobile]);

  const handleClearSort = () => {
    setSortData({
      orderBy: null,
      ...(hasOrderType ? { order: null } : {}),
    });
  };

  const handleClickDropdownItem = (value) => {
    if (value === "clear") {
      handleClearSort();
    } else {
      const [orderBy, order] = value.split("|");
      setSortData({
        orderBy,
        order,
      });
    }
  };

  return (
    <div className={classNames(styles["sort"], className)}>
      {!isMobile && <p className={styles["sort--title"]}>Sort by: </p>}
      {isMobile ? (
        <Dropdown
          menu={{
            items: [
              ...sortSelects,
              {
                type: "divider",
              },
              {
                key: "clear",
                label: "Clear sort",
                disabled: !sortData.orderBy && !sortData.order,
                danger: true,
              },
            ],
            selectable: true,
            selectedKeys: [`${sortData.orderBy}|${sortData.order}`],
            onClick: ({ key }) => handleClickDropdownItem(key),
          }}
          trigger="click"
        >
          <Button
            className={styles["sort--btn"]}
            icon={
              loading ? (
                <LoadingOutlined />
              ) : sortData.orderBy ? (
                <CheckIcon />
              ) : (
                <MoreHorizIcon />
              )
            }
            iconPosition="end"
          >
            Sort by
          </Button>
        </Dropdown>
      ) : (
        <>
          <Select
            style={{ width: 160 }}
            value={sortData.orderBy}
            onChange={(value) =>
              setSortData({
                orderBy: value,
                ...(hasOrderType ? { order: sortData.order || "desc" } : {}),
              })
            }
            options={sortSelects}
            placeholder="Select an option"
          />
          {hasOrderType && (
            <Select
              style={{ width: 130 }}
              value={sortData.order}
              onChange={(value) =>
                setSortData({
                  ...sortData,
                  order: value,
                })
              }
              options={[
                { value: "desc", label: "Descending" },
                { value: "asc", label: "Ascending" },
              ]}
              placeholder="Sort order"
            />
          )}
          <IconButton
            color="error"
            disabled={!sortData.orderBy && !sortData.order}
            onClick={() => handleClearSort()}
          >
            <BackspaceIcon />
          </IconButton>
        </>
      )}
    </div>
  );
};

export default SortSelect;
